var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "textShowMore", on: { mouseenter: _vm.onhandlemouseenter } },
    [
      _c(
        "el-tooltip",
        { attrs: { disabled: false, effect: "dark", placement: "top-start" } },
        [
          _c(
            "div",
            {
              staticClass: "textShowMoreContent",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.text))]),
              _c("i", {
                directives: [
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: _vm.text,
                    expression: "text",
                    arg: "copy",
                  },
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:success",
                    value: _vm.clipboardSuccess,
                    expression: "clipboardSuccess",
                    arg: "success",
                  },
                ],
                staticClass: "el-icon-document-copy copy-icon",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              }),
            ]
          ),
          _c(
            "div",
            {
              ref: "showMore",
              staticClass: "showMore",
              style: { "-webkit-line-clamp": _vm.lineClamp },
            },
            [_vm._v(_vm._s(_vm.text))]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }